import React, { useReducer, useContext } from "react";
import axios from "axios";
import OrdersContext from "./OrdersContext";
import OrdersReducer from "./OrdersReducer";
import {
  SET_SEARCH_FILTER,
  SEARCH_ORDER,
  SET_ORDER_MODAL,
  SET_MODAL_VALUES,
  SET_MODAL_ERRORS,
  SET_MODAL_STATES,
  SET_ORDER,
  ORDER_ERROR,
  UPDATE_CONTACT_INFO,
  UPDATE_SHIPPING_ADD,
  CREATE_ORDER_FULFILLMENT,
  EDIT_ORDER_FULFILLMENT,
  CALCULATE_ORDER_REFUND,
  CREATE_ORDER_REFUND,
  CLEAR_REFUND,
  SET_LOADING,
  GET_TRANSACTIONS,
} from "../../types";
import AuthContext from "../../auth/AuthContext";

const OrderState = (props) => {
  const initialState = {
    searchFilter: {
      by: "Transaction ID",
      value: "",
    },
    searchResult: null,
    order: null,
    order_error: null,
    modalOpen: false,
    modalFunction: null,
    modalValues: {},
    modalErrors: {},
    modalStates: {
      submitted: false,
      changed: false,
    },
    refund: null,
    refund_error: null,
    loading: false,
    transactions: null,
  };

  const [state, dispatch] = useReducer(OrdersReducer, initialState);
  const { user } = useContext(AuthContext);

  const setSearchFilter = (data) => {
    dispatch({
      type: SET_SEARCH_FILTER,
      payload: data,
    });
  };

  const searchOrder = async () => {
    try {
      const res = await axios.get("/api/orders/v1/search/", {
        params: state.searchFilter,
      });

      dispatch({
        type: SEARCH_ORDER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: ORDER_ERROR,
        payload: err.response,
      });
    }
  };

  const setModal = (open, function_name) => {
    dispatch({
      type: SET_ORDER_MODAL,
      payload: [open, function_name],
    });
  };

  const setValues = (data) => {
    dispatch({
      type: SET_MODAL_VALUES,
      payload: data,
    });
  };

  const setErrors = (data) => {
    dispatch({
      type: SET_MODAL_ERRORS,
      payload: data,
    });
  };

  const setModalStates = (data) => {
    dispatch({
      type: SET_MODAL_STATES,
      payload: data,
    });
  };

  const setOrder = (data) => {
    dispatch({
      type: SET_ORDER,
      payload: data,
    });
  };

  const updateContactInfo = async (store_name, customer_id, order_id, data) => {
    try {
      // Update Customer
      const res_customer = await axios.put("/api/orders/v1/customer/", {
        store_name,
        customer_id,
        params: {
          id: customer_id,
          email: data.email,
          phone: data.phone,
        },
      });

      if (res_customer.data.customer) {
        // Success
        // Update Order
        const res_order = await axios.put("/api/orders/v1/order/", {
          type: "contact",
          store_name,
          order_id,
          params: {
            id: order_id,
            email: data.email,
            phone: data.phone,
          },
          username: user.name,
        });

        dispatch({
          type: UPDATE_CONTACT_INFO,
          payload: res_order.data,
        });
      }
    } catch (err) {
      dispatch({
        type: ORDER_ERROR,
        payload: err.response.data,
      });
    }
  };

  const updateShippingAdd = async (store_name, order_id, data) => {
    try {
      // Update Order
      const res_order = await axios.put("/api/orders/v1/order/", {
        type: "shipping",
        store_name,
        order_id,
        params: {
          id: order_id,
          shipping_address: data,
        },
        username: user.name,
      });

      dispatch({
        type: UPDATE_SHIPPING_ADD,
        payload: res_order.data,
      });
    } catch (err) {
      dispatch({
        type: ORDER_ERROR,
        payload: err.response.data,
      });
    }
  };

  const createOrderFulfillment = async (
    order_id,
    store_name,
    line_items,
    data
  ) => {
    try {
      const res = await axios.post("/api/orders/v1/fulfillment", {
        order_id,
        store_name,
        line_items,
        tracking: data,
        username: user.name,
      });

      dispatch({
        type: CREATE_ORDER_FULFILLMENT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: ORDER_ERROR,
        payload: err.response.data,
      });
    }
  };

  const editOrderTracking = async (
    fulfillment_id,
    order_id,
    store_name,
    line_items,
    data
  ) => {
    try {
      const res = await axios.put("/api/orders/v1/fulfillment", {
        fulfillment_id,
        order_id,
        store_name,
        line_items,
        tracking: data,
        username: user.name,
      });

      dispatch({
        type: EDIT_ORDER_FULFILLMENT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: ORDER_ERROR,
        payload: err.response.data,
      });
    }
  };

  const calculateOrderRefund = async (
    store_name,
    order_id,
    line_items,
    shipping_fee
  ) => {
    try {
      // Remove Line Items With 0 Quantity
      let new_line_items = [];

      if (shipping_fee === "NaN") {
        shipping_fee = "0.00";
      }

      if (line_items) {
        line_items.map((each) => {
          if (each.quantity > 0) {
            new_line_items.push(each);
          }

          return new_line_items;
        });
      }

      dispatch({
        type: SET_LOADING,
      });

      const res = await axios.post("/api/orders/v1/refund/calculate", {
        store_name,
        order_id,
        line_items: new_line_items,
        shipping_fee,
      });

      dispatch({
        type: CALCULATE_ORDER_REFUND,
        payload: [res.data, null],
      });
    } catch (err) {
      // if (err.response.data === "Unavailable Shop") {
      //   dispatch({
      //     type: CALCULATE_ORDER_REFUND,
      //     payload: [null, "Unavailable Shop"],
      //   });
      // } else {
      dispatch({
        type: CALCULATE_ORDER_REFUND,
        payload: [null, null],
      });
      // }
    }
  };

  const createOrderRefund = async (store_name, order_id) => {
    try {
      const modalValues = state.modalValues;
      let refund = null;

      if (state.refund) {
        refund = Object.assign({}, state.refund);

        refund["notify"] = modalValues.notify_customer;

        if (modalValues.reasons) {
          refund["note"] = modalValues.reasons;
        }

        refund.transactions.map((each) => {
          return (each.kind = "refund");
        });
      }

      const res = await axios.post("/api/orders/v1/refund", {
        store_name,
        order_id,
        refund,
        values: modalValues,
        username: user.name,
      });

      dispatch({
        type: CREATE_ORDER_REFUND,
        payload: res.data,
      });
    } catch (err) {
      // console.log(err.response);
      // console.log(err.response.data);

      let msg = "No refund has been made.";

      if (err.response.data === "capture_id not found") {
        msg += ` ${err.response.data}`;
      }

      dispatch({
        type: ORDER_ERROR,
        payload: msg,
      });
    }
  };

  const clearRefund = () => {
    dispatch({
      type: CLEAR_REFUND,
      payload: [null, null],
    });
  };

  const clearOrderError = () => {
    dispatch({
      type: ORDER_ERROR,
      payload: null,
    });
  };

  const getTransactions = async (store_name, order_id) => {
    try {
      const res = await axios.get("/api/orders/v1/transactions/", {
        params: {
          store_name,
          order_id,
        },
      });

      dispatch({
        type: GET_TRANSACTIONS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: ORDER_ERROR,
        payload: err.response,
      });
    }
  };

  return (
    <OrdersContext.Provider
      value={{
        searchFilter: state.searchFilter,
        searchResult: state.searchResult,
        order: state.order,
        order_error: state.order_error,
        modalOpen: state.modalOpen,
        modalFunction: state.modalFunction,
        modalValues: state.modalValues,
        modalErrors: state.modalErrors,
        modalStates: state.modalStates,
        refund: state.refund,
        refund_error: state.refund_error,
        loading: state.loading,
        transactions: state.transactions,
        setSearchFilter,
        searchOrder,
        setOrder,
        setModal,
        setValues,
        setErrors,
        setModalStates,
        updateContactInfo,
        updateShippingAdd,
        createOrderFulfillment,
        editOrderTracking,
        calculateOrderRefund,
        createOrderRefund,
        clearRefund,
        clearOrderError,
        getTransactions,
      }}
    >
      {props.children}{" "}
    </OrdersContext.Provider>
  );
};

export default OrderState;
